<div class="section-heading action-heading">

  <div>

    <span class="section-kicker">
      Restaurant information
    </span>

    <h2>
      Store locations
    </h2>

    <p>
      Add, update or remove the locations
      shown on the public website.
    </p>

  </div>

  <button
    type="button"
    class="primary-btn"
    (click)="openLocationEditor()"
  >
    ＋ Add location
  </button>

</div>


<div class="entity-list">

  <article
    class="entity-card"
    *ngFor="
      let location of locations;
      trackBy: trackById
    "
  >

    <div class="entity-marker">
      <img
        [src]="branding.logoUrl()"
        alt=""
      />
    </div>


    <div class="entity-main">

      <div class="entity-title-row">

        <div>

          <h3>
            {{ location.name }}
          </h3>

          <p>
            {{ location.address }}
          </p>

        </div>

        <span
          class="active-pill"
          [class.inactive-pill]="!location.isActive"
        >
          {{ location.isActive ? 'Active' : 'Hidden' }}
        </span>

      </div>


      <div class="entity-details">

        <span>
          <strong>Phone</strong>
          {{ location.phone || 'Not provided' }}
        </span>

        <span>
          <strong>Hours</strong>
          {{ location.hours || 'Not provided' }}
        </span>

        <span>
          <strong>Status</strong>
          {{ location.isActive ? 'Active' : 'Inactive' }}
        </span>

      </div>

    </div>


    <div class="entity-actions">

      <button
        type="button"
        class="edit-btn"
        (click)="openLocationEditor(location)"
      >
        Edit
      </button>

      <button
        type="button"
        class="delete-btn"
        (click)="
          requestDelete(
            'location',
            location.id,
            location.name
          )
        "
      >
        Delete
      </button>

    </div>

  </article>


  <div
    *ngIf="!locationsLoading && !locations.length"
    class="panel empty-state large"
  >

    <strong>
      No store locations
    </strong>

    <p>
      Add the first location to begin displaying
      restaurants on the website.
    </p>

  </div>

</div>


<!-- LOCATION EDITOR -->

<div
  *ngIf="locationEditorOpen"
  class="modal-backdrop"
>

  <section
    class="editor-modal wide"
    role="dialog"
    aria-modal="true"
  >

    <header class="modal-header">

      <div>

        <span class="section-kicker">
          Store location
        </span>

        <h2>
          {{
            locationDraft.id
              ? 'Edit location'
              : 'Add location'
          }}
        </h2>

      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Close"
        [disabled]="isSavingLocation"
        (click)="closeLocationEditor()"
      >
        ×
      </button>

    </header>


    <form (ngSubmit)="saveLocation()">

      <div class="form-grid">

        <div class="form-field">

          <label for="location-name">
            Location name
          </label>

          <input
            id="location-name"
            name="name"
            [(ngModel)]="locationDraft.name"
            required
          />

        </div>


        <div class="form-field">

          <label for="location-phone">
            Phone number
          </label>

          <input
            id="location-phone"
            name="phone"
            [(ngModel)]="locationDraft.phone"
          />

        </div>


        <div class="form-field full-width">

          <label for="location-address">
            Full address
          </label>

          <input
            id="location-address"
            name="address"
            [(ngModel)]="locationDraft.address"
            required
          />

        </div>


        <div class="form-field">

          <label for="location-latitude">
            Latitude
          </label>

          <input
            id="location-latitude"
            name="latitude"
            type="number"
            step="any"
            [(ngModel)]="locationDraft.latitude"
            required
          />

          <span class="field-help">
            Leave as 0 to generate automatically.
          </span>

        </div>


        <div class="form-field">

          <label for="location-longitude">
            Longitude
          </label>

          <input
            id="location-longitude"
            name="longitude"
            type="number"
            step="any"
            [(ngModel)]="locationDraft.longitude"
            required
          />

          <span class="field-help">
            Leave as 0 to generate automatically.
          </span>

        </div>


        <div class="form-field full-width">

          <label for="location-hours">
            Store hours
          </label>

          <input
            id="location-hours"
            name="hours"
            [(ngModel)]="locationDraft.hours"
            placeholder="6:00 AM – 11:00 PM"
            required
          />

        </div>


        <div class="form-field">

          <label for="location-display-order">
            Display order
          </label>

          <input
            id="location-display-order"
            name="displayOrder"
            type="number"
            min="0"
            [(ngModel)]="locationDraft.displayOrder"
          />

        </div>


        <div class="form-field">

          <label class="checkbox-label">

            <input
              name="isActive"
              type="checkbox"
              [(ngModel)]="locationDraft.isActive"
            />

            Display this location

          </label>

        </div>

      </div>


      <div class="form-actions modal-actions">

        <button
          type="button"
          class="text-btn"
          [disabled]="isSavingLocation"
          (click)="closeLocationEditor()"
        >
          Cancel
        </button>


        <button
          type="submit"
          class="primary-btn save-location-btn"
          [disabled]="isSavingLocation"
        >

          @if (isSavingLocation) {

            <span class="button-spinner"></span>

            <span>
              {{
                isRetrievingCoordinates
                  ? 'Retrieving map coordinates...'
                  : 'Saving location...'
              }}
            </span>

          } @else {

            <span>
              Save location
            </span>

          }

        </button>

      </div>

    </form>

  </section>

</div>


<!-- DELETE CONFIRMATION -->

<div
  *ngIf="deleteRequest"
  class="modal-backdrop confirm-backdrop"
  (click)="cancelDelete()"
>

  <section
    class="confirm-modal"
    role="alertdialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="confirm-icon">
      !
    </div>

    <h2>
      Delete “{{ deleteRequest.label }}”?
    </h2>

    <p>
      This location will be permanently removed.
      This action cannot be undone.
    </p>

    <div class="form-actions">

      <button
        type="button"
        class="secondary-btn"
        (click)="cancelDelete()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="danger-btn"
        (click)="confirmDelete()"
      >
        Delete permanently
      </button>

    </div>

  </section>

</div>
